module.exports = __webpack_public_path__ + "static/media/logo.df97ec6e.png";